import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "stroke-miterlimit": "10",
  "font-family": "none",
  "font-weight": "none",
  "font-size": "none",
  "text-anchor": "none",
  style: {"mix-blend-mode":"normal"}
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M25.6 25.6h204.8v204.8H25.6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M128 42.667c47.13 0 85.333 38.203 85.333 85.333 0 47.13-38.203 85.333-85.333 85.333-47.13 0-85.333-38.203-85.333-85.333h17.066c0 37.7 30.567 68.267 68.267 68.267 37.7 0 68.267-30.567 68.267-68.267 0-37.7-30.567-68.267-68.267-68.267-23.467 0-44.169 11.836-56.448 29.867h22.315v17.067h-51.2v-51.2h17.066V76.8C75.298 56.064 100.087 42.667 128 42.667zm8.533 42.666v39.126l27.674 27.673-12.075 12.075-32.665-32.683v-46.19z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }